module.exports = __webpack_public_path__ + "static/media/12.Foreign Tour.5c42a36d.JPG";